<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">日本の女性VCリーダーに新たなチャンスを</h1>
                <span class="meta"> Posted in June 2023 </span>

                <figure>
                  <img class="img-fluid" src="img/blog/card/shizen-sprout.jpg" alt="">
                </figure>

<p>ベンチャー・キャピタル・ビジネスにおける多様性の欠如は世界的な問題である。私のブログの読者であれば、過去の暴論でご存知の通り、この悪質な問題はVCファンドのリターンに悪影響を与え、女性やその他の存在感の薄い起業家を阻害し、地域のスタートアップ・エコシステムの健全性を阻害し、社会全体からイノベーションを奪うと考えている。</p>
<p>日本のVCコミュニティを見渡してみると、この問題と無縁ではないことがわかる。女性が設立したVCファンドという称賛に値する例外はいくつかあるが（AN Ventures、MPower、NextBlueなどが思い浮かぶ）、こうした稀な例は片手で数えられるほどだ。</p>
<p>かつて同じように順位が低かったヨーロッパからの教訓は、VCにおける多様性の欠如は構造的、歴史的、文化的要因に起因するものであり、それに対処するには各方面からの努力が必要だということだ。</p>
<p>私たち自然キャピタルには、その解決に貢献する責任があります。また、完璧は時に進歩の敵になることもあると信じています。そのため、理想的な包括的解決策を何年もかけて理論化し、それによって不作為の陰に隠れてしまうよりは、今すぐ行動を起こすことを選んだのです。</p>

<h2 class="subheading">スプラウトの紹介：VCイン・レジデンスの機会</h2>

<p>私たちは、自然資本スプラウト・イニシアチブを発表できることを嬉しく思います。Sproutは、VCファンドの運営を志す野心的な日本の女性のためのフルタイムの機会です。VC-in-residence」または「GP-in-training」プログラムとお考えください。スプラウトの参加者には、以下のような特典があります。スプラウトの参加者に対しては、私たちのファンドで彼らを雇用し、VCファンド運営のあらゆる側面に触れさせ、私たちがスタートアップへの投資で得た数十年の経験（理想的には私たちの悪い癖を除いたもの）を可能な限り伝え、彼らが準備ができたと判断した時点で、自分のファンドでGPとしてブランチアウトできるようにします。</p>
<p>GPになるまでの期間は、参加者の経験や個人的な快適さによって異なります。このプログラムの中核的なビジョンは、日本でより多くの女性が設立したファンドを促進することですが、自然キャピタルの内部でフルGPになることも、可能性としては選択肢になり得ます。</p>
<p>様々な経験を持つ女性候補者の応募が可能です。投資銀行、コンサルティング、スタートアップ、ベンチャーキャピタルでの経験がある方は特に適していると思われます。ただし、厳しい条件は設けておりません。プロフェッショナルとしての野心と、スタートアップを支援したいという強い意欲が重要な条件です。最初の参加者については、日本語が流暢に話せることを条件とします（英語は流暢である必要はありません）。</p>
<p>現在応募を受け付けており、夏以降に最初の参加者を決定する予定です。興味のある方は sprout@shizen.vc までご連絡ください。履歴書と一緒に志望動機もお送りください。応募の秘密は厳守いたします。(日本語でも英語でも、どちらでも結構です）。</p>

              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
